import { css } from 'styled-components';

// Color name generator: https://color-name-generator.com/
export const CssVariables = css`
  :root {
    --american-silver: #cfcfcf;
    --attorney: #3d3f56;
    --amber: #ffbf00;
    --attorneyRGB: 61, 63, 86;
    --alpine-goat: #f0f0f7;
    --alpine-goatRGB: 240, 240, 247;
    --ash-to-ash: #4d4d4d;
    --ash-tree-bark: #cfcfd5;
    --angry-gargoyle: #9697a7;
    --approval-green: #009688;
    --bleuchatel-blue: #4482ff;
    --boogie-blast: #19913d;
    --boogie-blastRGB: 25, 145, 61;
    --chateau-green: #47a764;
    --bright-grey: #ebecf0;
    --blue-chaos: #52a0f8;
    --blue-rose: #2e2c6d;
    --blue-party-parrot: #808bff;
    --blue-party-parrotRGB: 128, 139, 255;
    --black-oak: #4f4f4f;
    --bermudagrass: #67c46e;
    --bleached-silk: #f2f2f2;
    --blue-de-france: #2f80ed;
    --brilliant-white: #ecf3ff;
    --brilliant-azure: #3399ff;
    --butternut: #ffa177;
    --mandys-pink: #f7b492;
    --byzantine-night-blue: #6371fa;
    --byzantine-night-blueRGB: 99, 113, 250;
    --cobalite: #a3a0fb;
    --cobaliteRGB: 163, 160, 251;
    --carbon: #333333;
    --carbon2: #323332;
    --coronation-blue: #5c4da0;
    --moody-blue: #8075cd;
    --christmas-silver: #e0e0e0;
    --cotton-ball: #f3f5fd;
    --cool-frost: #e5e6ed;
    --cyber-lavender: #e8e7ff;
    --cerebral-grey: #cccccc;
    --c64-ntsc: #5677fc;
    --diamond-cut: #e8e8f1;
    --diamond-cutRGB: 232, 232, 241;
    --diamonds-in-the-sky: #e3e1e1;
    --dissolved-denim: #e3eaf4;
    --diva: #bea0ff;
    --dishy-coral: #ee9391;
    --dodger-blue: #3b86ff;
    --dodger-blueRGB: 59, 134, 255;
    --dr-white: #fafafa;
    --december-dawn: #e0e1e9;
    --december-dawnRGB: 224, 225, 233;
    --dull: #727272;
    --democrat: #03a9f4;
    --filtered-light: #b4b4c6;
    --filtered-lightRGB: 180, 180, 198;
    --flushed: #e25656;
    --fennel-flower: #79acff;
    --fusion: #afb42b;
    --grapefruit: #ff5b58;
    --june-berry: #9996b9;
    --hill-giant: #e0efdf;
    --hill-lands: #8bc34a;
    --white: #fff;
    --whiteRGB: 255, 255, 255;
    --white-solid: #f5f7fa;
    --white-pomelo: #f4f7fa;
    --white-smoke: #f5f5f5;
    --white-as-heaven: #fefefe;
    --white-as-heavenRGB: 254, 254, 254;
    --whale-shark: #607d8b;
    --black: #000;
    --blackRGB: 0, 0, 0;
    --gulfweed: #38923f;
    --ruthless-empress: #51369a;
    --ruthless-empressRGB: 81, 54, 154;
    --wild-iris: #2f2e50;
    --wild-irisRGB: 47, 46, 80;
    --misty-lavender: #d9d9e2;
    --indolence: #a09fad;
    --imagination: #dfdff2;
    --icy-lilac: #e6eaf8;
    --island-green: #27ae60;
    --khmer-curry: #eb5757;
    --noghrei-silver: #bdbdbd;
    --orochimaru: #d9d9d9;
    --orochimaruRGB: 217, 217, 217;
    --overcast-night: #424170;
    --mercury: #ebebeb;
    --masterpiece: #a2a2a9;
    --purple-veil: #d4d5df;
    --purple-emperor: #6b3dbc;
    --pumping-spice: #f94d4d;
    --placebo: #e7e7e7;
    --pompelmo: #ff6565;
    --pompelmoRGB: 255, 101, 101;
    --wewak: #f48384;
    --pinball: #d3d3d3;
    --pink-theory: #ffe4e4;
    --pink-spyro: #9c27b0;
    --primavera: #70a580;
    --pacific-line: #2d3446;
    --question-mark-block: #f2994a;
    --rich-green: #1a913e;
    --royalty: #5838a3;
    --roxy-brown: #795548;
    --metro: #828395;
    --lunar-outpost: #80808a;
    --lead: #212121;
    --lightish-blue: #3775f2;
    --lynx-white: #f7f7f7;
    --lust: #e51c23;
    --linderhof-garden: #259b24;
    --steam: #dddddd;
    --sweet-flower: #e1e2ea;
    --snowflake: #f0f0f0;
    --salt-mountain: #d9fcff;
    --spinel-black: #43425d;
    --spinel-blackRGB: 67, 66, 93;
    --silverberry: #bcbccb;
    --silverberryRGB: 188, 188, 203;
    --simply-peachy: #ffc06a;
    --simply-peachyRGB: 255, 192, 106;
    --squids-ink: #4d4f5c;
    --spring-slumber-green: #b9f4bc;
    --special-delivery: #a4afb7;
    --soap: #cfc7f1;
    --sugar-poppy: #e48585;
    --spooky-ghost: #d3d3d9;
    --smashing-pumpkins: #ff5722;
    --trolley-grey: #828282;
    --tuna: #47474e;
    --tunaRGB: 71, 71, 78;
    --timid-cloud: #dddde5;
    --tranquil-pond: #788195;
    --venetian-nights: #6d52fc;
    --voracious-white: #fceeee;
    --vitamin-c: #ff9800;
    --wash-me: #fafbff;
    --windswept-beach: #e2e4e6;
    --gainsboro: #dedede;
    --gainsboroRGB: 222, 222, 222;
    --galactic-civilization: #381f8a;
    --ghost-white: #f8f8fe;
    --solitude: #f1f3f6;
    --deep-koamaru: #352e76;
    --whisper: #ededed;
    --blue-gem: #42299a;
    --brink-pink: #f75d81;
    --zambezi: #595959;
    --grams-hair: #f5f6f8;
    --beluga: #f1f1f1;
    --doctor: #f9f9f9;
    --stonewall-grey: #c1c1c1;
    --whiteout: #fbfbfb;
    --desired-dawn: #d8d8d8;
    --grey: #808080;
    --nostalgia-perfume: #d7dafc;
    --black-market: #272644;
    --cotton-flannel: #9293a2;
    --alice-blue: #f0f8ff;
    --golden-koi: #e9a346;
    --citronella: #62b774;
    --panorama-blue: #34bac9;
    --red: #ff0000;
    --fuchsia-blue: #8653c6;
    --maui-mist: #eff1f5;
    --dusty-chimney: #868698;
    --dusty-chimneyRGB: 134, 134, 152;
    --velvet-crest: #9493c0;
    --moon-white: #e9f2ff;
    --blood-burst: #ff4d4f;
    --baby-talk-grey: #bababa;
    --placebo-red: #fbeded;
    --dugong: #707070;
    --lavender-blue-shadow: #8590fb;
    --safflower-red: #d9363e;
    --go-green: #00b16a;
    --blue-haze: #bcbccc;
    --snowbank: #e9e9e9;
    --midnight-express: #23223b;
    --mellow-melon: #e91e63;
    --maldives: #00bcd4;
    --sugar-crystal: #f5f4ff;
    --limo-sceneRGB: 74, 74, 80;
    --prune-plum: #18163d;
    --night-fog: #301d5d;
    --night-in-manchester: #3f51b5;
    --clear-purple: #422674;
    --clear-chill: #1890ff;
    --tristesse: #07061e;
    --steel: #797979;
    --warm-blue: #505cdb;
    --greengage: #8ac489;
    --minsk: #382d65;
    --tetsu-kon-blue: #131950;
    --pale-grey: #fcfdfe;
    --miami-white: #cfcef1;
    --praise-of-shadow: #241858;
    --void: #080b26;
  }
`;
